import React from "react";

export default function GatewayNotice({ title, children, tone = "info" }) {
  return (
    <div className={`gatewayNotice gatewayNotice--${tone}`} role={tone === "error" ? "alert" : "status"}>
      <span className="gatewayNotice__mark" aria-hidden="true">◇</span>
      <div>
        {title ? <strong>{title}</strong> : null}
        {children ? <small>{children}</small> : null}
      </div>
    </div>
  );
}
